/**
 * CardAction2 시나리오
 * 커스터마이징 가능한 레이아웃 - action2.svg
 */

import { ReactComponent as Action2SVG } from "@/assets/animations/action2.svg";
import type { MotionScenario } from "../types";

export const cardAction2Scenario: MotionScenario = {
  svgComponent: Action2SVG,

  transitionSpeed: 1500,

  repeat: {
    mode: "once",
  },

  viewBoxAnimation: {
    duration: 800,
    easing: "easeInOut",
  },

  scenes: [
    // Scene 0: 초기 상태
    {
      id: 0,
      name: "initial",
      elements: [
        {
          selector: 'g[data-name="action1"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="action2"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="action3"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="Panel - Waiting"]',
          opacity: 1,
          translateX: 0,
        },
        {
          selector: 'g[data-name="Panel - Treatment"]',
          opacity: 1,
          translateX: 0,
        },
        {
          selector: 'g[data-name="Panel - Complete"]',
          opacity: 1,
          translateX: 0,
        },
        {
          selector: 'g[data-name="Patient Details"]',
          opacity: 1,
          translateX: 0,
        },
        {
          selector: 'g[data-name="Patient Memo"]',
          opacity: 1,
          translateX: 0,
        },
        {
          selector: 'g[data-name="Current Chart"]',
          opacity: 1,
          translateX: 0,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="Panel - Waiting"]',
        zoom: 0.5, // 약 2배 확대
      },
    },

    // Scene 1: Panel - Waiting 이동
    {
      id: 1,
      name: "waiting-move",
      elements: [
        {
          selector: 'g[data-name="action1"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="Panel - Reservation"]',
          opacity: 0,
          translateX: -240,
        },
        {
          selector: 'g[data-name="Panel - Waiting"]',
          opacity: 1,
          translateX: -240,
        },
        {
          selector: 'g[data-name="Panel - Treatment"]',
          opacity: 1,
          translateX: -240,
        },
        {
          selector: 'g[data-name="Panel - Complete"]',
          opacity: 1,
          translateX: -240,
        },

        {
          selector: 'g[data-name="Patient Details"]',
          opacity: 1,
          translateX: -240,
        },
        {
          selector: 'g[data-name="Patient Memo"]',
          opacity: 1,
          translateX: -240,
        },
        {
          selector: 'g[data-name="Current Chart"]',
          opacity: 1,
          translateX: -240,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="Panel - Waiting"]',
        zoom: 0.5, // 약 2배 확대
      },
      glowEffect: true,
      glowSelector: 'g[data-name="action1"]',
    },

    // Scene 2: Panel - Treatment 이동
    {
      id: 2,
      name: "treatment-move",
      elements: [
        {
          selector: 'g[data-name="action1"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action2"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="Panel - Waiting"]',
          opacity: 0, // 사라짐
          translateX: -470,
        },
        {
          selector: 'g[data-name="Panel - Treatment"]',
          opacity: 1,
          translateX: -470,
        },
        {
          selector: 'g[data-name="Panel - Complete"]',
          opacity: 1,
          translateX: -470,
        },
        {
          selector: 'g[data-name="Patient Details"]',
          opacity: 1,
          translateX: -470, //
        },
        {
          selector: 'g[data-name="Patient Memo"]',
          opacity: 1,
          translateX: -470,
        },
        {
          selector: 'g[data-name="Current Chart"]',
          opacity: 1,
          translateX: -470,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="Panel - Waiting"]',
        zoom: 0.5, // 약 2배 확대
      },
      glowEffect: true,
      glowSelector: 'g[data-name="action2"]',
    },

    // Scene 3: Panel - Complete 이동
    {
      id: 3,
      name: "complete-move",
      elements: [
        {
          selector: 'g[data-name="action3"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="Panel - Treatment"]',
          opacity: 0, // 사라짐
          translateX: -700,
        },
        {
          selector: 'g[data-name="Panel - Complete"]',
          opacity: 1,
          translateX: -700,
        },
        {
          selector: 'g[data-name="Patient Details"]',
          opacity: 1,
          translateX: -700,
        },
        {
          selector: 'g[data-name="Patient Memo"]',
          opacity: 1,
          translateX: -700,
        },
        {
          selector: 'g[data-name="Current Chart"]',
          opacity: 1,
          translateX: -700,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="Panel - Waiting"]',
        zoom: 0.5, // 약 2배 확대
      },
      glowEffect: true,
      glowSelector: 'g[data-name="action3"]',

    },
  ],
};
